import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

import AuthContext from '../../Context/authContext';

const RequireAuth = ({ children }) => {
    const { isAuthenticated } = useContext(AuthContext);
    const location = useLocation();
    
    if (!isAuthenticated) {
        return <Navigate to='/login' state={{ from: location.pathname }} />
    }
    return children;
}

export default RequireAuth;
